import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
}

const CheckmarkCircleIcon: React.FC<Props> = ({ className }) => {
  return (
    <SVGIcon viewBox="0 0 12 12">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM8.29289 3.29289L5 6.58579L3.70711 5.29289C3.31658 4.90237 2.68342 4.90237 2.29289 5.29289C1.90237 5.68342 1.90237 6.31658 2.29289 6.70711L4.29289 8.70711C4.68342 9.09763 5.31658 9.09763 5.70711 8.70711L9.70711 4.70711C10.0976 4.31658 10.0976 3.68342 9.70711 3.29289C9.31658 2.90237 8.68342 2.90237 8.29289 3.29289Z"
        fill="#2B2B2B"
        className={className}
      />
    </SVGIcon>
  );
};

export default CheckmarkCircleIcon;
